import {atom, DefaultValue, selector, selectorFamily} from "recoil";

export const checkOutInState = atom({
    key: 'checkOutIn',
    default: {
        type: null,                 // 'out' | 'in' | 'subIn'
        recoveryMode: false,
        step: {
            active: null,
            numSteps: null
        },
        raFetchedData: null,        // serverData
        substitutionCheckIn: null,
        checkVehicleStatus: null,   // ICheckedVehicleStatus
        existingDamage: {           // existing damage
            visited: false,
            internal: [],
            external: []
        },
        checkDamage: {              // new damage - used only in step CheckDamage
            platePhoto: null,
            internal: [],
            external: []
        },
        events: {
            internal: [],
            external: [],
        },
        equipmentsEvent: null,      // save equipments form
        checkEquipments: null,
        severityList: [],
        partsAndPositionsList: [],
        eventsList: [],
        bufferDataAction: {
            damage: {
                action: null,
                data: null
            },
            event: {
                action: null,
                data: null
            },
            equipments: {
                action: null,
                previousCheckData: null          // previous check missing list
            }
        },
        summary: null,
        extraCostInput: {
            fuelExtra: '0',
            batteryExtra: '0',
            refuelServiceAmount: '0',
            extraTermicLitres: '',
            termicFuelPrice: '',
            extraSocKws: '',
            extraSocKwsPrice: '',
            oneWayServiceAmount: '0',
            washExtra: '0',
            washDescription: '',
            washPhoto: null,
            recoveryExtra: '0',
            recoveryDescription: '',
            recoveryPhoto: null
        }
    }
});

export const checkOutInModeState = selector<any>({
    key: 'checkOutInMode',
    get: ({ get }) => get(checkOutInState).type,
    set: ({ set, get }, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            type: newValue instanceof DefaultValue ? get(checkOutInState).type : newValue
        })
    }
});

export const recoveryModeState = selector<any>({
    key: 'recoveryMode',
    get: ({ get }) => get(checkOutInState).recoveryMode,
    set: ({ set, get }, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            recoveryMode: newValue instanceof DefaultValue ? get(checkOutInState).recoveryMode : newValue
        })
    }
});

export const checkOutInStepState = selector<any>({
    key: 'checkOutInStep',
    get: ({ get }) => get(checkOutInState).step,
    set: ({ set, get }, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            step: newValue instanceof DefaultValue ? get(checkOutInState).step : newValue
        })
    }
});

export const raFetchedDataState = selector<any>({
    key: 'raFetchedData',
    get: ({ get }) => get(checkOutInState).raFetchedData,
    set: ({ set, get }, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            raFetchedData: newValue instanceof DefaultValue ? get(checkOutInState).raFetchedData : newValue
        })
    }
});

export const substitutionCheckInState = selector<any>({
    key: 'nonRunningVehicle',
    get: ({ get }) => get(checkOutInState).substitutionCheckIn,
    set: ({ set, get }, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            substitutionCheckIn: newValue instanceof DefaultValue ? get(checkOutInState).substitutionCheckIn : newValue
        })
    }
});

export const raFetchedDataPartState = selectorFamily<any, string>({
    key: 'raFetchedDataPart',
    get: part => ({ get }) => get(raFetchedDataState)[part],
    // per adesso non serve set
    set: part => ({ get, set }, newValue) => {
        set(raFetchedDataState, {
            ...get(raFetchedDataState),
            [part]: newValue instanceof DefaultValue ? false : newValue
        })
    }
});

export const existingDamageState = selector<any>({
    key: 'existingDamage',
    get: ({get}) => get(checkOutInState).existingDamage,
    set: ({get, set}, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            existingDamage: newValue instanceof DefaultValue ? get(checkOutInState).existingDamage : newValue
        })
    }
});

export const existingDamageTypeState = selectorFamily<any, string>({
    key: 'existingDamageTypeState',
    get: type => ({ get }) => get(existingDamageState)[type],
    set: type => ({ get, set }, newValue) => {
        set(existingDamageState, {
            ...get(existingDamageState),
            [type]: newValue instanceof DefaultValue ? false : newValue
        })
    }
});

export const checkVehicleStatusState = selector<any>({
   key: 'checkVehicleStatus',
    get: ({get}) => get(checkOutInState).checkVehicleStatus,
    set: ({get, set}, newValue) => {
       set(checkOutInState, {
           ...get(checkOutInState),
           checkVehicleStatus: newValue instanceof DefaultValue ? get(checkOutInState).checkVehicleStatus : newValue
       })
    }
});

export const checkDamageState = selector<any>({
    key: 'checkDamage',
    get: ({ get }) => get(checkOutInState).checkDamage,
    set: ({ set, get }, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            checkDamage: newValue instanceof DefaultValue ? get(checkOutInState).checkDamage : newValue
        })
    }
});

export const checkDamageTypeState = selectorFamily<any, string>({
    key: 'checkDamageType',
    get: type => ({ get }) => get(checkDamageState)[type],
    set: type => ({ get, set }, newValue) => {
        set(checkDamageState, {
            ...get(checkDamageState),
            [type]: newValue instanceof DefaultValue ? false : newValue
        })
    }
});

export const eventsState = selector<any>({
    key: 'events',
    get: ({ get }) => get(checkOutInState).events,
    set: ({ set, get }, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            events: newValue instanceof DefaultValue ? get(checkOutInState).events : newValue
        })
    }
});

export const eventsTypeState = selectorFamily<any, string>({
    key: 'eventsType',
    get: type => ({ get }) => get(eventsState)[type],
    set: type => ({ get, set }, newValue) => {
        set(eventsState, {
            ...get(eventsState),
            [type]: newValue instanceof DefaultValue ? false : newValue
        })
    }
});

export const checkEquipmentsState = selector<any>({
    key: 'checkEquipments',
    get: ({get}) => get(checkOutInState).checkEquipments,
    set: ({get, set}, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            checkEquipments: newValue instanceof DefaultValue ? get(checkOutInState).checkEquipments : newValue
        })
    }
});

export const equipmentsEventState = selector<any>({
    key: 'equipmentsEventState',
    get: ({get}) => get(checkOutInState).equipmentsEvent,
    set: ({get, set}, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            equipmentsEvent: newValue instanceof DefaultValue ? get(checkOutInState).equipmentsEvent : newValue
        })
    }
});

export const checkOutInSeverityState = selector<any>({
    key: 'checkOutInSeverity',
    get: ({get}) => get(checkOutInState).severityList,
    set: ({get, set}, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            severityList: newValue instanceof DefaultValue ? get(checkOutInState).severityList : newValue
        })
    }
});

export const checkOutInPartsAndPositionsState = selector<any>({
    key: 'checkOutInPartsAndPositions',
    get: ({get}) => get(checkOutInState).partsAndPositionsList,
    set: ({get, set}, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            partsAndPositionsList: newValue instanceof DefaultValue ? get(checkOutInState).partsAndPositionsList : newValue
        })
    }
});

export const checkOutInEventsListState = selector<any>({
    key: 'checkOutInEventsList',
    get: ({get}) => get(checkOutInState).eventsList,
    set: ({get, set}, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            eventsList: newValue instanceof DefaultValue ? get(checkOutInState).eventsList : newValue
        })
    }
});

export const checkOutInBufferDataActionState = selector<any>({
    key: 'checkOutInBufferDataAction',
    get: ({get}) => get(checkOutInState).bufferDataAction,
    set: ({get, set}, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            bufferDataAction: newValue instanceof DefaultValue ? get(checkOutInState).bufferDataAction : newValue
        })
    }
});

export const checkOutInBufferDataActionTypeState = selectorFamily<any, string>({
    key: 'checkOutInBufferDataActionType',
    get: type => ({ get }) => get(checkOutInBufferDataActionState)[type],
    set: type => ({ get, set }, newValue) => {
        set(checkOutInBufferDataActionState, {
            ...get(checkOutInBufferDataActionState),
            [type]: newValue instanceof DefaultValue ? false : newValue
        })
    }
});

export const summaryState = selector<any>({
    key: 'summary',
    get: ({ get }) => get(checkOutInState).summary,
    set: ({ set, get }, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            summary: newValue instanceof DefaultValue ? get(checkOutInState).summary : newValue
        })
    }
})

export const extraCostInputState = selector<any>({
    key: 'extraCostInput',
    get: ({ get }) => get(checkOutInState).extraCostInput,
    set: ({ set, get }, newValue) => {
        set(checkOutInState, {
            ...get(checkOutInState),
            extraCostInput: newValue instanceof DefaultValue ? get(checkOutInState).extraCostInput : newValue
        })
    }
})
